define(["jquery"], function ($) {

    var apiUrl = (window.scan && window.scan.apiUrl) ? window.scan.apiUrl : "";

    ScanTranslations._instance = null;

    function ScanTranslations() {
        this.values = {};
    }

    ScanTranslations.prototype.translate = function(key) {
        return this.values[key] || key;
    };

    ScanTranslations.prototype.loadValues = function() {
        var language = document.documentElement.lang || 'en';

        // the filename is defined in Scan.Engine.Resources.SerializeScanTranslationsToJson.CreateDictionaryJsonFile()
        return $.ajax({
            url: apiUrl + "/ui/SCAN/assets/scripts/scan_translations." + language + ".js",
            type: "GET",
            dataType: "json",
            context: this
        });
    };

    return {
        getInstance: function() {
            var deferred = new $.Deferred();
            if (ScanTranslations._instance) {
                deferred.resolve(ScanTranslations._instance);
            } else {
                var translations = new ScanTranslations();
                translations.loadValues().done(function(data) {
                    translations.values = Object.freeze(data);
                    ScanTranslations._instance = translations;
                    deferred.resolve(ScanTranslations._instance);
                }).fail(function(data) {
                    console.log("Error requesting scan_translations", data);
                    deferred.reject();
                });
            }

            return deferred.promise();
        }
    };
});
